import React from "react";

// Elegant moving background: slow-drifting gold radial blobs over a deep dark base.
// Tuned to stay subtle (dark stays dominant) and light on mobile.
const AnimatedBackground = ({ base = "#0B0B0C", accent = "#B2A475" }) => {
  const blob = (opacity, size, pos, anim) => ({
    position: "absolute",
    width: size,
    height: size,
    borderRadius: "9999px",
    filter: "blur(80px)",
    background: `radial-gradient(circle, ${accent}${opacity} 0%, transparent 68%)`,
    willChange: "transform",
    ...pos,
    animation: anim,
  });
  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" style={{ backgroundColor: base }} aria-hidden>
      <div style={blob("2e", "min(55vw, 460px)", { top: "-12%", left: "-12%" }, "floatBlob 24s ease-in-out infinite")} />
      <div style={blob("20", "min(50vw, 420px)", { bottom: "-16%", right: "-14%" }, "floatBlob 30s ease-in-out infinite reverse")} />
      <div style={blob("16", "min(38vw, 320px)", { top: "40%", left: "45%" }, "floatBlob 36s ease-in-out infinite")} />
      <div className="grain-overlay" />
    </div>
  );
};

export default AnimatedBackground;
